export default __webpack_public_path__ + "static/media/homevideo.23309670.jpg";